import { defineStore } from 'pinia'
import {
  fetchAdminModifierTemplates,
  fetchAdminToppingOptions,
} from '@/entities/admin/api/adminRestaurantsApi'
import { emptyModifierTemplates } from '@/entities/admin/lib/mapModifierTemplates'

function createEntry(templates = emptyModifierTemplates()) {
  return {
    variantGroups: templates.variantGroups ?? [],
    toppings: templates.toppings ?? [],
  }
}

export const useAdminModifiersStore = defineStore('adminModifiers', {
  state: () => ({
    byRestoId: {},
    isLoading: false,
    error: null,
  }),

  getters: {
    forResto: (state) => (restoId) => {
      const id = String(restoId ?? '').trim()
      return state.byRestoId[id] ?? createEntry()
    },
  },

  actions: {
    clear() {
      this.byRestoId = {}
      this.isLoading = false
      this.error = null
    },

    async fetchModifiers(
      restoId,
      {
        force = false,
        fetchTemplates = fetchAdminModifierTemplates,
        fetchToppings = fetchAdminToppingOptions,
      } = {},
    ) {
      const id = String(restoId ?? '').trim()
      if (!id) {
        return
      }

      if (this.byRestoId[id] && !force) {
        return
      }

      this.isLoading = true
      this.error = null
      try {
        const [templates, toppings] = await Promise.all([
          fetchTemplates(id),
          fetchToppings(id),
        ])
        this.byRestoId = {
          ...this.byRestoId,
          [id]: createEntry({
            variantGroups: templates.variantGroups,
            toppings,
          }),
        }
      } catch (error) {
        this.error = error
      } finally {
        this.isLoading = false
      }
    },
  },
})
